import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoPrestador } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoPrestadorService extends BaseResourceService<FavorecidoPrestador> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-prestadores`, injector);
  }

}
